import { AsyncLoad } from "../../components/asyncLoad/AsyncLoad";
import { PublicPage } from "../../components/pages/publicPage/PublicPage";
import { SystemApi } from "../../api/SystemApi";
import styles from "./DownloadSoftwareBundleHotfixes.module.scss";
import { useRequest } from "../../hooks/useRequest";
import { useRouteParam } from "../../hooks/useRouteParam";

export const DownloadSoftwareBundleHotfixesPage: React.FC = () => {
  const request = useRequest();
  const systemId = useRouteParam<string>("systemId");
  const checksumSha1 = useRouteParam<string>("checksumSha1");

  return (
    <PublicPage
      className={styles.center}
      iconName="package"
      showPageInfo={false}
    >
      <AsyncLoad
        load={async () => {
          await request.send(async () => {
            await SystemApi.downloadSoftwareBundleHotfixesPublic(
              systemId,
              checksumSha1
            );
          });
        }}
      ></AsyncLoad>
    </PublicPage>
  );
};
